import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import DadosOutorganteModel from '../model/dados-outorgante.model';

@Injectable({
  providedIn: 'root'
})
export class OutorgaService {

  private outorgadoSource = new BehaviorSubject<[number, object, DadosOutorganteModel]>(null);
  private dadosOutorgado: number;

  getOutorgado() {
    return this.outorgadoSource.asObservable();
  }

  changeOutorgado(outorgado: number, servicos: object, dadadosOutorgante: DadosOutorganteModel) {
    this.dadosOutorgado = outorgado;
    this.outorgadoSource.next([outorgado, servicos, dadadosOutorgante]);
  }

  getDadosOutorgado() {
    return this.dadosOutorgado;
  }

}




